/**
 * =========================================================================================
 * Account - Settings
 * =========================================================================================
 *
 */
import React, {Suspense} from 'react';
import {Route, Switch, useRouteMatch} from 'react-router-dom';
import * as Icon from 'ubs-icons';
// import {Error403, Error404} from "../common/error-pages";
import Error404 from "../../common/error/Error";
import SideMenuLayout from "../../../components/side-menu-layout";
// Settings


const MasterConfig = React.memo(() => {
    const {path} = useRouteMatch();

    console.log("path",path)
    return (
        <React.Fragment>
            {/** Lazy Loading sub router setup using code splitting functionality */}
            <Suspense fallback={<div className="u_preloader"><Icon.Preloader/></div>}>
                <Switch>
                    {/** setting */}

                    <Route path="*" component={Error404}/>
                </Switch>
            </Suspense>
        </React.Fragment>
    );
});


const Settings = () => {
    return (
        <React.Fragment>
            {/** Lazy Loading sub router setup */}
            <Suspense fallback={<div className="u_preloader"><Icon.Preloader/></div>}>
                <Switch>
                    <Route path="/:orgId/manage/settings" component={MasterConfig}/>
                </Switch>
            </Suspense>
        </React.Fragment>
    )
}

export default Settings;

